import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackBookCtaClick } from '../utils/gtag';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const goToBookPage = () => {
    setMobileMenuOpen(false);
    trackBookCtaClick('header');
    window.location.href = '/book';
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-container">
          <Link to="/" className="logo">
            <h1>NORCAL MOBILE</h1>
            <span className="logo-tagline">Oil Change Service</span>
          </Link>

          <button
            className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
            <li><Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>HOME</Link></li>
            <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>ABOUT</Link></li>
            <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>CONTACT</Link></li>
            <li className="nav-cta">
              <button onClick={goToBookPage} className="nav-book-btn">
                BOOK NOW
              </button>
            </li>
          </ul>

          <div className="header-contact-btns">
            <a href="tel:9168188494" className="header-btn header-btn-call">
              <svg className="header-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              Call Us
            </a>
            <a href="sms:9168188494" className="header-btn header-btn-text">
              <svg className="header-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              Text Us
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
